module.exports = function FundraiserRegistrationController($scope, $state, $document) {
  var vm = this;
  vm.fundraiser = {};
  vm.submit = {};

  var init = function() {
  };
  init();

  vm.toggle = function(e) {
    e.preventDefault();
    vm.preview = !vm.preview;
  };

  vm.submit = function() {

  };
}
